/**
 * FAQ Accordion Component
 * 
 * 使用方法:
 * 1. HTML: <section class="faq" data-faq>...</section>
 * 2. JS: このファイルを読み込む
 * 3. 自動的に初期化される
 */

class FAQAccordion {
  constructor(element) {
    this.element = element;
    this.items = element.querySelectorAll('.faq__item');
    this.currentOpenItem = null;
    
    this.init();
  }

  init() {
    if (!this.items.length) return;

    this.items.forEach(item => {
      const trigger = item.querySelector('.faq__trigger');
      const content = item.querySelector('.faq__content');

      if (!trigger || !content) return;

      // aria-expanded="true"が設定されている場合、デフォルトで開く
      if (trigger.getAttribute('aria-expanded') === 'true') {
        this.open(item);
        this.currentOpenItem = item;
      }

      trigger.addEventListener('click', () => this.handleClick(item));
    });
  }

  handleClick(item) {
    const trigger = item.querySelector('.faq__trigger');
    const content = item.querySelector('.faq__content');
    const icon = item.querySelector('.faq__icon');
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    // 他の開いているアイテムがあれば閉じる
    if (this.currentOpenItem && this.currentOpenItem !== item) {
      this.close(this.currentOpenItem);
    }

    if (isExpanded) {
      this.close(item);
      this.currentOpenItem = null;
    } else {
      this.open(item);
      this.currentOpenItem = item;
    }
  }

  open(item) {
    const trigger = item.querySelector('.faq__trigger');
    const content = item.querySelector('.faq__content');
    const icon = item.querySelector('.faq__icon');

    content.classList.add('faq__content--open');
    content.style.maxHeight = content.scrollHeight + 'px';
    trigger.setAttribute('aria-expanded', 'true');
    if (icon) icon.classList.add('faq__icon--open');
  }

  close(item) {
    const trigger = item.querySelector('.faq__trigger');
    const content = item.querySelector('.faq__content');
    const icon = item.querySelector('.faq__icon');

    if (content) {
      content.style.maxHeight = '0px';
      content.classList.remove('faq__content--open');
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (icon) icon.classList.remove('faq__icon--open');
  }

  // 全て閉じる
  closeAll() {
    this.items.forEach(item => this.close(item));
    this.currentOpenItem = null;
  }

  // 特定のインデックスを開く
  openByIndex(index) {
    if (index >= 0 && index < this.items.length) {
      const item = this.items[index];
      if (this.currentOpenItem) {
        this.close(this.currentOpenItem);
      }
      this.open(item);
      this.currentOpenItem = item;
    }
  }
}

// 自動初期化
(function() {
  function init() {
    const faqSections = document.querySelectorAll('[data-faq]');
    faqSections.forEach(section => {
      if (!section.hasAttribute('data-faq-initialized')) {
        section.setAttribute('data-faq-initialized', 'true');
        new FAQAccordion(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
